/**
 * 表格底部合計列的一格：schema 標了 `sum` 的欄位才算，其餘回 null（那格留白）。
 *
 * 數字欄照小數位數最多的那列對齊後用整數加，不直接浮點相加 ——
 * pg 的 numeric 送過來是字串（"12.345"），0.1 + 0.2 那種尾巴會讓人以為主檔填錯。
 * 數字欄的空值不算進去，另外回報有幾列沒填，合計才不會悄悄少一截。
 * bool 欄算「是」有幾列；文字欄算有填的列數（05 的串列編號留空 = 空接，所以就是已接幾串）。
 *
 * @returns {{ text: string, missing: number } | null}
 */
function columnTotal (rows, col) {
  if (!col.sum) return null
  const filled = rows.filter((r) => r[col.name] !== null && r[col.name] !== undefined && r[col.name] !== '')
  const missing = rows.length - filled.length

  if (col.type === 'bool') return { text: `${filled.filter((r) => r[col.name]).length} 是`, missing: 0 }
  if (col.type !== 'number' && col.type !== 'int') return { text: `${filled.length} 筆`, missing: 0 }

  const decimals = Math.max(0, ...filled.map((r) => (String(r[col.name]).split('.')[1] || '').length))
  const scale = 10 ** decimals
  const units = filled.reduce((s, r) => s + Math.round(Number(r[col.name]) * scale), 0)
  const text = (units / scale).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  return { text, missing }
}

export { columnTotal }
